import React from "react";
import { philosophy } from "../mock";
import Reveal from "./Reveal";

const Philosophy = () => {
  return (
    <section id="philosophy" className="relative overflow-hidden scroll-mt-24 md:scroll-mt-32">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${philosophy.bgImage})` }}
      />
      <div className="absolute inset-0 bg-white/35" />
      <div className="absolute inset-0 bg-gradient-to-b from-white/30 via-white/15 to-white/40" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24 text-center">
        <Reveal>
          <p className="text-[#5AA84A] font-semibold tracking-[0.22em] text-sm mb-8">
            {philosophy.eyebrow}
          </p>
        </Reveal>

        <Reveal delay={80}>
          <p className="mx-auto max-w-4xl font-['Montserrat'] font-normal text-neutral-500 text-base md:text-lg leading-relaxed md:whitespace-nowrap">
            {philosophy.intro}
          </p>
        </Reveal>

        <Reveal delay={200}>
          <h2
            className="mt-28 md:mt-32 font-extrabold italic tracking-[-0.02em] leading-[0.95] text-[#7B3FA7] text-5xl sm:text-6xl md:text-7xl lg:text-8xl"
            style={{ fontStyle: "italic" }}
          >
            {philosophy.headline}
          </h2>
        </Reveal>

        <Reveal delay={320}>
          <p className="mt-16 md:mt-20 mx-auto max-w-2xl md:max-w-none font-['Montserrat'] font-normal text-neutral-500 text-base md:text-lg leading-relaxed md:whitespace-nowrap">
            {philosophy.sub}
          </p>
        </Reveal>

        <Reveal delay={420}>
          <p className="mt-6 md:mt-8 font-['Montserrat'] font-normal text-neutral-500 text-base md:text-lg leading-relaxed">
            {philosophy.outro}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Philosophy;
